import { DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS } from '@platform-frontend/util';

export const PRICE_DECREASE_NOTIFICATION_PRIORIZATION_LEVEL = DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS['info'] + 1;
export const PRICE_INCREASE_NOTIFICATION_PRIORIZATION_LEVEL = DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS['success'] + 1;
export const EULA_UPDATE_NOTIFICATION_PRIORIZATION_LEVEL = DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS['success'] + 2;
export const TERMS_OR_PRIVACY_POLICY_UPDATE_NOTIFICATION_PRIORIZATION_LEVEL = DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS['success'] + 3;
